<template>
  <el-dialog
    :title="'Lịch sử thao tác camera - Lớp: ' + (className || '')"
    :visible.sync="dialogVisible"
    width="85%"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    top="5vh"
  >
    <div v-if="loadError" class="history-error-banner">
      <span class="error-text">
        <i class="el-icon-warning-outline" />
        {{ errorMessage || "Không thể tải lịch sử thao tác camera." }}
      </span>
      <el-button
        type="danger"
        size="mini"
        plain
        icon="el-icon-refresh"
        @click="fetchData()"
      >
        Thử lại
      </el-button>
    </div>

    <el-table
      ref="historyTable"
      v-loading="loadingData"
      :element-loading-text="$tableLoading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255,255,255, 0.5)"
      highlight-current-row
      row-key="operationId"
      :data="historyRows"
      :empty-text="tableEmptyText"
      :header-cell-style="tableHeaderColor"
      :max-height="$tableMaxHeightSmall"
      border
    >
      <el-table-column
        type="index"
        :index="indexMethod"
        label="STT"
        width="55"
        align="center"
      />

      <el-table-column
        label="Thời gian"
        width="165"
        align="center"
      >
        <template slot-scope="scope">
          <span>
            <i class="el-icon-time" style="margin-right: 4px; color: #409EFF" />
            {{ scope.row.changedAt | formatDateTime }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
        label="Người thao tác"
        width="190"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.actorName" style="font-weight: 500;">
            <i class="el-icon-user" style="margin-right: 4px; color: #67C23A" />
            {{ scope.row.actorName }}
          </span>
          <span v-else style="color: #909399; font-style: italic;">
            <i class="el-icon-user" style="margin-right: 4px;" />
            Tài khoản #{{ scope.row.actorUserId }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
        label="Loại thao tác"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.addedCount > 0 && scope.row.removedCount > 0"
            type="warning"
            size="small"
            effect="plain"
          >
            Thêm & Loại bỏ
          </el-tag>
          <el-tag
            v-else-if="scope.row.addedCount > 0"
            type="success"
            size="small"
            effect="plain"
          >
            Thêm
          </el-tag>
          <el-tag
            v-else-if="scope.row.removedCount > 0"
            type="danger"
            size="small"
            effect="plain"
          >
            Loại bỏ
          </el-tag>
          <el-tag
            v-else
            type="info"
            size="small"
            effect="plain"
          >
            Không đổi
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="Camera thêm" min-width="220">
        <template slot-scope="scope">
          <div v-if="scope.row.addedCount > 0">
            <div style="font-weight: 600; color: #67C23A; margin-bottom: 4px;">
              <i class="el-icon-circle-plus-outline" /> Thêm {{ scope.row.addedCount }} mắt:
            </div>
            <div class="camera-tag-list">
              <el-tag
                v-for="cam in scope.row.addedCameras"
                :key="cam.id"
                type="success"
                size="mini"
                style="margin: 2px 4px 2px 0;"
              >
                {{ cam.camName }}
              </el-tag>
            </div>
          </div>
          <span v-else style="color: #C0C4CC;">—</span>
        </template>
      </el-table-column>

      <el-table-column label="Camera loại bỏ" min-width="220">
        <template slot-scope="scope">
          <div v-if="scope.row.removedCount > 0">
            <div style="font-weight: 600; color: #F56C6C; margin-bottom: 4px;">
              <i class="el-icon-remove-outline" /> Loại bỏ {{ scope.row.removedCount }} mắt:
            </div>
            <div class="camera-tag-list">
              <el-tag
                v-for="cam in scope.row.removedCameras"
                :key="cam.id"
                type="danger"
                size="mini"
                style="margin: 2px 4px 2px 0;"
              >
                {{ cam.camName }}
              </el-tag>
            </div>
          </div>
          <span v-else style="color: #C0C4CC;">—</span>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <div class="dialog-footer-content">
        <el-pagination
          background
          :current-page="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="historyTotal"
        />
        <div class="dialog-action-buttons">
          <el-button
            size="medium"
            type="primary"
            plain
            icon="el-icon-refresh"
            :loading="loadingData"
            @click="fetchData()"
          >
            Làm mới
          </el-button>
          <el-button type="danger" size="medium" @click="closeDialog()">
            <i class="el-icon-circle-close" />
            <span>{{ $t("button.close") }}</span>
          </el-button>
        </div>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import SchoolConfigService from "@/services/SchoolService/SchoolConfigService";

export default {
  name: "ClassCameraHistoryDialog",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      idClass: "",
      className: "",
      historyRows: [],
      historyTotal: 0,
      currentPage: 1,
      pageSize: 20,
      loadingData: false,
      loadError: false,
      errorMessage: "",
    };
  },
  computed: {
    tableEmptyText() {
      if (this.loadingData) {
        return "Đang tải dữ liệu...";
      }
      if (this.loadError) {
        return "Không tải được lịch sử thao tác camera. Vui lòng bấm thử lại.";
      }
      return "Chưa có lịch sử thay đổi camera được ghi nhận";
    },
  },
  methods: {
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    closeDialog() {
      this.$emit("dialog-close");
    },
    initialHistoryData(row) {
      this.idClass = row.id;
      this.className = row.className || "";
      this.currentPage = 1;
      this.pageSize = 20;
      this.historyRows = [];
      this.historyTotal = 0;
      this.loadError = false;
      this.errorMessage = "";
      this.fetchData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    async fetchData(resetPage = false) {
      if (!this.idClass) return;
      if (resetPage) {
        this.currentPage = 1;
      }
      const targetClassId = this.idClass;
      this.loadingData = true;
      this.loadError = false;
      this.errorMessage = "";
      try {
        const response = await SchoolConfigService.findClassCameraHistory(
          this.idClass,
          this.currentPage - 1,
          this.pageSize
        );
        // Ngăn chặn race condition khi người dùng đổi lớp khác
        if (this.idClass !== targetClassId) return;

        const historyPage = response && response.data && response.data.data;
        if (historyPage) {
          this.historyRows = historyPage.content || [];
          this.historyTotal = historyPage.totalElements || 0;
        } else {
          this.historyRows = [];
          this.historyTotal = 0;
        }
      } catch (error) {
        if (this.idClass !== targetClassId) return;
        this.loadError = true;
        let msg = "Không thể tải lịch sử thao tác camera";
        if (error && error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message;
        }
        this.errorMessage = msg;
        this.$message.error(msg);
      } finally {
        if (this.idClass === targetClassId) {
          this.loadingData = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__title {
  font-size: 20px;
  font-weight: bold;
  color: #303133;
}
.history-error-banner {
  margin-bottom: 15px;
  padding: 10px 16px;
  background-color: #fef0f0;
  border-radius: 4px;
  border: 1px solid #fde2e2;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.error-text {
  color: #f56c6c;
  font-size: 14px;
  display: flex;
  align-items: center;
  i {
    margin-right: 6px;
    font-size: 16px;
  }
}
.camera-tag-list {
  display: flex;
  flex-wrap: wrap;
}
.dialog-footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.dialog-action-buttons {
  display: flex;
  gap: 10px;
}
</style>
